import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import images from "../constants/images";

const products = [
  {
    id: 1,
    name: "Gate-To-Gate",
    description:
      "Zab Cabs enables you to travel from your location in a specific city to a destination of your choice in another city at a fixed cost.",
    price: "₹250/km",
    image: images.realcar1,
  },
  {
    id: 2,
    name: "24x7 Support",
    description:
      "We understand that your needs don’t follow a schedule, which is why our services are available 24 hours a day, 7 days a week.",
    price: "₹400/km",
    image: images.realcar4,
  },
  {
    id: 3,
    name: "Highly Competent Drivers",
    description:
      "Our driver partners are ranked on 8+ parameters, ensuring complete customer satisfaction.",
    price: "₹600/km",
    image: images.realcar2,
  },
  {
    id: 4,
    name: "Luxury Rides",
    description:
      "Experience premium comfort with our fleet of high-end luxury vehicles, perfect for special occasions and business travel.",
    price: "₹800/km",
    image: images.realcar3,
  },
  {
    id: 5,
    name: "Safe & Secure",
    description:
      "Your safety is our top priority. Our cabs are equipped with GPS tracking, emergency buttons, and verified drivers.",
    price: "₹500/km",
    image: images.realcar5,
  },
];

const vehicleList = [
  { name: "WagonR", amount: "₹1800 + Toll" },
  { name: "Sedan", amount: "₹2000 + Toll" },
  { name: "Ertiga", amount: "₹2500 + Toll" },
  { name: "Toyota Rumion", amount: "₹2700 + Toll" },
  { name: "Toyota Innova", amount: "₹3800 + Toll" },
  { name: "Innova Crysta", amount: "₹4200 + Toll" }
];

const Services = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen">
      {/* Background Image with Navbar & Hero Section */}
      <div
        style={{
          backgroundImage: `url(${images.carimage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backdropFilter: "blur(5px)",
        }}
        className="bg-fixed text-white min-h-[80vh] flex flex-col"
      >
        <Navbar />
        <div className="flex-grow flex items-center justify-center text-center px-4">
          <div className="max-w-6xl">
            <h1 className="text-4xl font-bold mb-6">Our Ride Services</h1>
            <p className="text-xl text-yellow-300 drop-shadow-md">
              Choose from our range of ride services designed to suit your needs.
            </p>
          </div>
        </div>
      </div>

      {/* Products Section */}
      <main className="flex-grow py-16 px-4">
        <section className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-400">
                Our Fleet Collection
              </span>
            </h2>
            <p className="text-lg text-gray-600 max-w-xl mx-auto">
              Discover the perfect blend of comfort, style, and performance.
            </p>
          </div>

          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            spaceBetween={20}
            loopAdditionalSlides={products.length}
            watchSlidesProgress={true}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 2.5,
              slideShadows: true,
            }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true, dynamicBullets: true }}
            navigation={true}
            loop={true}
            modules={[EffectCoverflow, Autoplay, Pagination, Navigation]}
            className="h-[620px]"
          >
            {products.concat(products).map((product, index) => (
              <SwiperSlide key={index} className="max-w-sm lg:max-w-md !h-auto">
                <div className="group relative h-auto rounded-2xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-500 ease-out">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-blue-600/20 backdrop-blur-sm" />
                  {/* Image Container */}
                  <div className="relative h-96 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500 ease-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  </div>
                  {/* Content Container */}
                  <div className="bg-white/95 backdrop-blur-sm p-8">
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {product.description}
                    </p>
                    {/* <button
                      onClick={() => navigate("/contactus")}
                      className="w-full py-3.5 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                    >
                      Book Now →
                    </button> */}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>

        {/* New Visual Section - Our Service Features */}
        <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-500 text-white">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Why Choose Zab Tours?</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="p-6">
                <img
                  src={images.handshake}
                  alt="Reliable Service"
                  className="mx-auto mb-4 w-24 h-24 rounded-md"
                />
                <h3 className="text-xl font-bold mb-2">Reliable Service</h3>
                <p>
                  Always on time, ensuring your journey is smooth and hassle-free.
                </p>
              </div>
              <div className="p-6">
                <img
                  src={images.security}
                  alt="Safety Guaranteed"
                  className="mx-auto mb-4 w-24 h-24 rounded-md"
                />
                <h3 className="text-xl font-bold mb-2">Safety Guaranteed</h3>
                <p>
                  Our drivers and vehicles are rigorously vetted to ensure your safety.
                </p>
              </div>
              <div className="p-6">
                <img
                  src={images.earth}
                  alt="Nationwide Coverage"
                  className="mx-auto mb-4 w-24 h-18 rounded-md"
                />
                <h3 className="text-xl font-bold mb-2">Nationwide Coverage</h3>
                <p>
                  We cover every state—no matter where you are, our service reaches you.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Zab Tours & Travels Information Section bg-gray-100*/}
        <section className="py-16 px-4 ">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Zab Tours & Travels</h2>
            <p className="text-lg text-gray-600 font-medium">Your Trusted Travel Partner</p>

            {/* Contact Information */}
            <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="p-6 bg-white rounded-xl shadow-md border flex flex-col justify-center items-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Why Choose Us?</h3>
                <ul className="text-gray-600 space-y-3 text-left">
                  <li className="flex items-start">
                    <span className="text-blue-600 font-semibold mr-2">✔</span>
                    Reliable & Punctual Services
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 font-semibold mr-2">✔</span>
                    Affordable & Transparent Pricing
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 font-semibold mr-2">✔</span>
                    Well-Maintained & Comfortable Vehicles
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 font-semibold mr-2">✔</span>
                    Professional & Courteous Drivers
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 font-semibold mr-2">✔</span>
                    Easy Online Booking & Support
                  </li>
                </ul>
              </div>


              {/* Services */}
              <div className="p-6 bg-white rounded-xl shadow-md border flex flex-col justify-center items-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Drop – Pickup Rates</h3>
                <ul className="space-y-2 text-center">
                  {vehicleList.map((item, index) => (
                    <li key={index}>
                      <strong>{item.name}</strong>
                      {item.amount && <> – {item.amount}</>}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Routes */}
              <div className="p-6 bg-white rounded-xl shadow-md border justify-center items-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">All Outstation Rates</h3>
                <ul className="text-gray-800 space-y-2 text-wrap text-sm text-left">
                  {[
                    { name: "WagonR", amount: "₹11 per km, ₹300 package charge" },
                    { name: "Sedan", amount: "₹12 per km, ₹300 package charge" },
                    { name: "Ertiga", amount: "₹14 per km, ₹300 package charge" },
                    { name: "Toyota Rumion", amount: "₹16 per km, ₹300 package charge" },
                    { name: "Toyota Innova", amount: "₹20 per km, ₹300 package charge" },
                    { name: "Pune - Shirdi", amount: "" },
                    { name: "Innova Crysta", amount: "₹22 per km, ₹300 package charge" }
                  ].map((item, index) => (
                    <li key={index} className="pb-2">
                      <strong>{item.name}</strong>
                      {item.amount && <> – {item.amount}</>}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="p-6 bg-white rounded-xl shadow-md border flex flex-col justify-center items-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Popular Routes</h3>
                <ul className="text-gray-600 space-y-1">
                  {[
                    "Pune - Mumbai",
                    "Mumbai - Pune",
                    "Pune - Mahabaleshwar",
                    "Pune - Bhimashankar",
                    "Pune - Nashik",
                    "Pune - Shirdi",
                    "Mumbai - Shirdi",
                  ].map((route, index) => (
                    <li key={index} className=" pb-2">{route}</li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Call-to-Action */}
            <div className="mt-10">
              <button
                onClick={() => navigate("/contactus")}
                className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition-all"
              >
                Book Your Ride Now
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Services;
